import { NewTag } from "@/components/Tag";

import {
  owned_icon_true as ownedIcon,
  untradeableOnly as untradeableIcon,
} from "../../../../../icons";

export const Name = ({
  name,
  newPlayer,
  owned,
  untradeable,
  sbcStorage,
  isEvolutions,
  cardName,
}: {
  name: string;
  newPlayer: boolean;
  owned: boolean;
  untradeable: boolean;
  sbcStorage: boolean;
  isEvolutions?: boolean;
  cardName?: string;
}) => {
  const nameLimit = isEvolutions ? 15 : 20;
  return (
    <div className="flex justify-between w-full px-2 pr-0 large:pr-2 desktop:h-full desktop:justify-start desktop:gap-x-2">
      <div className="flex my-auto gap-x-1">
        <h3 className="py-1 text-base font-bold md-sm:text-lg large:text-xl truncate">
          {name?.length > nameLimit
            ? cardName && cardName.length > nameLimit
              ? cardName.slice(0, nameLimit - 3) + "..."
              : cardName || name
            : name?.length === nameLimit
              ? name.slice(0, nameLimit - 3) + "..."
              : name}
        </h3>
        {owned && <div className="w-3 desktop:w-4">{ownedIcon}</div>}
        {untradeable && (
          <div className="w-[13px] desktop:w-[17px]">{untradeableIcon}</div>
        )}
        {sbcStorage && (
          <img
            className="w-[13px] h-[13px] desktop:w-[17px] desktop:h-[17px] my-auto"
            src={
              import.meta.env.VITE_APP_ASSETS_BASE_URL +
              "/fc24/filtersbar/sbc-storage.svg"
            }
            alt="sbc"
          />
        )}
      </div>
      {newPlayer && (
        <div className="my-auto mr-2 desktop:mr-0">
          <NewTag />
        </div>
      )}
    </div>
  );
};
